import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

export const StyledTrustedTitle = styled.p`
	color: rgba(255, 255, 255, 0.5);
	text-align: center;
	font-size: 13px;
	font-weight: 400;
	letter-spacing: 0.14em;
	text-transform: uppercase;
	margin: 0 auto 30px;
	padding: 0 20px;
`;

export const StyledHero = styled.section`
	overflow: hidden;
	padding: 50px 00px 50px;
	transform-style: preserve-3d;
	background-color: #010101;

	--icons-hover-base-duration: 5s;

	.hero-content-container {
		margin-top: 100px;

		.header-background-overlay {
			position: absolute;
			height: 750px;
			width: 100%;

			z-index: -1;
			top: 0;
			left: 0;

			display: flex;
			gap: 20px;

			* {
				box-sizing: content-box;
			}

			> img {
				position: absolute;
				right: 0;
			}

			.shadow {
				border: 1px rgba(53, 53, 53, 0.3) solid;
				border-radius: 5px;

				filter: blur(2.6px);

				&.left {
					transform: rotateX(30deg) rotateY(-20deg);
					position: absolute;
				}

				&.right {
					transform: rotateX(-32deg) rotateY(-20deg);
					position: absolute;
				}
			}

			//left side
			.shadow-left-L {
				background: linear-gradient(
					244.07deg,
					rgba(46, 46, 46, 0.8) -7.79%,
					rgba(0, 0, 0, 0.8) 70.79%
				);

				top: 45%;
				left: 5%;

				animation: left-shadow-float
					calc(var(--icons-hover-base-duration) * 0.625) ease-in-out infinite;
			}

			.shadow-left-S {
				background: linear-gradient(
					275.12deg,
					rgba(46, 46, 46, 0.4) 3.42%,
					rgba(0, 0, 0, 0.4) 112.81%
				);

				top: 60%;
				left: 29%;

				animation: left-shadow-float calc(var(--icons-hover-base-duration))
					ease-in-out reverse infinite;
			}

			.shadow-left-M {
				background: linear-gradient(
					275.12deg,
					rgba(46, 46, 46, 0.8) 3.42%,
					rgba(0, 0, 0, 0.8) 112.81%
				);

				&.a {
					top: 10%;
					left: 12.5%;

					animation: left-shadow-float
						calc(var(--icons-hover-base-duration) * 0.75) ease-in-out infinite;
				}
				&.b {
					top: 40%;
					left: 23%;
					animation: left-shadow-float
						calc(var(--icons-hover-base-duration) * 1.125) ease-in-out reverse
						infinite;
				}
			}

			.graph {
				top: 22%;
				left: 12%;
				animation: images-float calc(var(--icons-hover-base-duration) * 0.75)
					ease-in-out reverse infinite;
			}

			.watch {
				top: 7%;
				left: 28%;
				animation: images-float calc(var(--icons-hover-base-duration))
					ease-in-out infinite;
			}

			.star {
				top: 60%;
				left: 17%;
				animation: images-float calc(var(--icons-hover-base-duration) * 1.25)
					ease-in-out infinite;
			}

			// right side
			.shadow-right-S {
				background: linear-gradient(282.95deg, #2e2e2e 10.72%, #000000 119.44%);

				right: 22%;
				top: 34%;

				animation: right-shadow-float
					calc(var(--icons-hover-base-duration) * 1.125) ease-in-out infinite;
			}
			.shadow-right-M {
				background: linear-gradient(
					259.65deg,
					rgba(46, 46, 46, 0.8) -20.54%,
					rgba(0, 0, 0, 0.8) 104.52%
				);

				right: 16%;
				top: 14%;

				animation: right-shadow-float
					calc(var(--icons-hover-base-duration) * 0.875) ease-in-out reverse
					infinite;
			}
			.shadow-right-L {
				background: linear-gradient(
					259.65deg,
					rgba(46, 46, 46, 0.8) -20.54%,
					rgba(0, 0, 0, 0.8) 104.52%
				);

				right: 6%;
				top: 40%;

				animation: right-shadow-float
					calc(var(--icons-hover-base-duration) * 1.25) ease-in-out reverse
					infinite;
			}

			.play {
				right: 24%;
				top: 11%;
				animation: images-float calc(var(--icons-hover-base-duration) * 0.875)
					ease-in-out reverse infinite;
			}

			.music {
				right: 13%;
				top: 25%;
				animation: images-float calc(var(--icons-hover-base-duration) * 1.125)
					ease-in-out infinite;

				@media screen and (max-width: ${CSSVars.breakpointMD}) {
					top: 37%;
				}
			}

			.chat {
				right: 15%;
				top: 47%;
				animation: images-float calc(var(--icons-hover-base-duration) * 1.125)
					ease-in-out infinite;
			}

			// layout on mobile
			@media screen and (max-width: ${CSSVars.breakpointLG}) {
				*:not(.graph, .play, .star, .shadow-right-S, .shadow-right-M, .music) {
					display: none;
				}

				.graph {
					width: 60px;
					height: auto;
					left: -30px;
					top: 30.5%;
				}

				.star {
					width: 80px;
					height: auto;
					top: 8%;
					left: 16%;
				}

				.play {
					width: 84px;
					height: auto;
					top: 8%;
					right: -15px;
				}

				.shadow-right-S {
					right: 12%;
					top: 10%;
					filter: blur(2px);
					opacity: 0.8;
				}
				.shadow-right-M {
					right: -14px;
					top: 28%;

					filter: blur(4.7px);
					opacity: 0.8;
				}
			}

			/* placing star next to title gradient on each screen side */
			@media screen and (max-width: ${CSSVars.breakpointMD}) {
				.star {
					left: 6%;
				}

				.music {
					right: 6%;
				}

				.play {
					right: -40px;
				}
			}
			@media screen and (max-width: ${CSSVars.breakpointSM}) {
				.star {
					left: 3%;
				}

				.shadow-right-S {
					right: 19%;
					top: 15%;
				}
			}
		}

		// social proof pill above the title
		.hero-proof-pill {
			width: fit-content;
			margin: 0 auto 35px;
			padding: 8px 22px 8px 12px;
			display: flex;
			align-items: center;
			border-radius: 999px;
			border: 1px solid rgba(255, 255, 255, 0.12);
			background-color: rgba(255, 255, 255, 0.04);

			.rating-wrapper {
				margin: 0;
				flex-wrap: nowrap;
				gap: 10px;

				.rating {
					flex-direction: row;
					align-items: center;
					gap: 8px;

					p {
						white-space: nowrap;
					}
				}
			}

			@media screen and (max-width: ${CSSVars.breakpointSM}) {
				padding: 6px 16px 6px 10px;

				.rating-wrapper .rating svg {
					display: none;
				}
			}
		}

		.hero-title {
			color: ${CSSVars.white};
			text-align: center;
			font-weight: 300;
			font-size: clamp(42px, 5.5vw, 76px);
			line-height: 1.12;
			letter-spacing: -0.02em;
			width: min(95%, 1200px);
			margin: 0 auto;

			.gradient-phrase {
				font-weight: 400;
				white-space: nowrap;
				background: linear-gradient(90deg, #ff979c 0%, #8e90ff 100%);
				background-clip: text;
				-webkit-background-clip: text;
				color: transparent;
			}

			.second-line {
				display: block;
			}
		}

		.title-description {
			color: white;

			width: min(80%, 600px);
			margin: auto;
			font-size: 16px;
			white-space: break-spaces;
			text-align: center;
			line-height: 24px;

			margin-top: 20px;
			margin-bottom: 30px;

			@media screen and (max-width: ${CSSVars.breakpointLG}) {
				margin-bottom: 20px;
			}
		}

		.rating-scores {
			display: flex;
			align-items: center;
			justify-content: center;
			gap: 10px;
			margin-top: 20px;

			color: ${CSSVars.white};
			font-size: 14px;
			font-weight: 300;

			.star {
				color: #ffc24d;
			}

			strong {
				font-weight: 600;
			}

			.divider {
				opacity: 0.5;
			}
		}

		.category-links {
			display: flex;
			flex-wrap: wrap;
			align-items: center;
			justify-content: center;
			gap: 8px;
			max-width: 800px;
			margin: 25px auto 0;
			padding: 0 20px;

			a {
				color: rgba(255, 255, 255, 0.7);
				font-size: 13px;
				font-weight: 300;
				line-height: 1;
				padding: 7px 14px;
				border: 1px solid rgba(255, 255, 255, 0.12);
				border-radius: 999px;
				transition: color 0.2s ease, border-color 0.2s ease,
					background-color 0.2s ease;

				&:hover {
					color: ${CSSVars.white};
					border-color: rgba(76, 79, 255, 0.8);
					background-color: rgba(76, 79, 255, 0.08);
				}

				&.all-widgets {
					border: none;
					padding: 7px 4px;
					margin-left: 4px;
					color: ${CSSVars.white};
					font-weight: 400;

					span {
						display: inline-block;
						transition: transform 0.2s ease;
					}

					&:hover {
						background: none;
						color: ${CSSVars.blue400};

						span {
							transform: translateX(3px);
						}
					}

					@media (prefers-reduced-motion: reduce) {
						span,
						&:hover span {
							transition: none;
							transform: none;
						}
					}
				}
			}
		}
	}

	// animations
	@keyframes left-shadow-float {
		0% {
			transform: rotateX(30deg) rotateY(-20deg) translateY(0px);
		}
		50% {
			transform: rotateX(30deg) rotateY(-20deg) translateY(-10px);
		}
		100% {
			transform: rotateX(30deg) rotateY(-20deg) translateY(0px);
		}
	}

	@keyframes images-float {
		0% {
			transform: translateY(0px);
		}
		50% {
			transform: translateY(-10px);
		}
		100% {
			transform: translateY(0px);
		}
	}

	@keyframes right-shadow-float {
		0% {
			transform: rotateX(-32deg) rotateY(-20deg) translateY(0px);
		}
		50% {
			transform: rotateX(-32deg) rotateY(-20deg) translateY(-8px);
		}
		100% {
			transform: rotateX(-32deg) rotateY(-20deg) translateY(0px);
		}
	}
`;
